import React, { useState, useContext } from "react";
import axios from "../axios";
import { useCookies } from "react-cookie";
import LoginContext from "../context/LoginContext";
import { useNavigate } from "react-router-dom";

function LoginRegister() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [activeTab, setActiveTab] = useState("loginButton");
  const [cookies, setCookies] = useCookies(["access_token"]);
  const [failedLoginMessage, setFailedLoginMessage] = useState("");
  const [registrationMessage, setRegistrationMessage] = useState("");
  const [resetPasswordMessage, setResetPasswordMessage] = useState("");
  const [resendVerification, setResendVerification] = useState(false);
  const [verificationMessage, setVerificationMessage] = useState("");
  const { isLoggedIn, setIsLoggedIn } = useContext(LoginContext);
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setFailedLoginMessage("");
    setPassword("");
    setResendVerification(false);

    try {
      const response = await axios.post("/users/login", {
        email,
        password,
      });
      if (response.data.message) {
        setIsLoggedIn(false);
        setFailedLoginMessage(response.data.message);
        if (response.data.message === "Account not verified") {
          setResendVerification(true);
        }
      } else {
        setCookies("access_token", response.data.access_token);
        localStorage.setItem("userRole", response.data.role);
        setTimeout(() => {
          navigate("/mixer");
        }, 500);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleResendVerification = async (e) => {
    e.preventDefault();
    setFailedLoginMessage("");
    setVerificationMessage(`Resending email verification to ${email}`);
    setResendVerification(false);
    try {
      const response = await axios.post("/users/resendVerification", {
        email,
      });

      setVerificationMessage(response.data.message);
    } catch (err) {
      console.error(err);
    }
  };

  const handleCreateUser = async (e) => {
    e.preventDefault();
    setRegistrationMessage("Creating account...");
    try {
      const response = await axios.post("/users/createUser", {
        firstName,
        lastName,
        password,
        email,
      });
      setFirstName("");
      setLastName("");
      setEmail("");
      setPassword("");
      setRegistrationMessage(response.data.message);
    } catch (err) {
      console.error(err);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setFailedLoginMessage("");
    setRegistrationMessage("Resetting password...");
    try {
      const response = await axios.post("/users/resetPassword", {
        email,
      });
      setResetPasswordMessage(response.data.message);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="container">
      {" "}
      <div className="row justify-content-center">
        <div
          id="loginRegister"
          className="col-lg-4 col-md-6 col-sm-10 col-xs-12"
          style={{
            border: "1px solid gray",
            borderRadius: "15px",
            padding: "20px",
          }}
        >
          <div className="loginButtons text-center">
            <button
              id="loginButton"
              className={activeTab === "loginButton" ? "active" : ""}
              onClick={(e) => setActiveTab(e.target.id)}
            >
              Login
            </button>
            -or-
            <button
              id="registerButton"
              className={activeTab === "registerButton" ? "active" : ""}
              onClick={(e) => {
                setActiveTab(e.target.id);
                setFailedLoginMessage("");
                setVerificationMessage("");
              }}
            >
              Create Account
            </button>
          </div>
          <div className="text-center">
            {failedLoginMessage !== "" && (
              <p style={{ color: "red" }}>{failedLoginMessage}</p>
            )}
            {verificationMessage !== "" && <p>{verificationMessage}</p>}
            {resendVerification && (
              <p
                style={{ color: "blue", cursor: "pointer" }}
                onClick={handleResendVerification}
              >
                Resend Verification Email?
              </p>
            )}
          </div>
          <div className="">
            {activeTab === "loginButton" ? (
              <Login
                email={email}
                setEmail={setEmail}
                password={password}
                setPassword={setPassword}
                handleLogin={handleLogin}
                isVisible={isVisible}
                setIsVisible={setIsVisible}
                resetPasswordMessage={resetPasswordMessage}
                setResetPasswordMessage={(message) =>
                  setResetPasswordMessage(message)
                }
                handleResetPassword={handleResetPassword}
              />
            ) : (
              <Register
                firstName={firstName}
                setFirstName={setFirstName}
                lastName={lastName}
                setLastName={setLastName}
                password={password}
                setPassword={setPassword}
                email={email}
                setEmail={setEmail}
                handleCreateUser={handleCreateUser}
                registrationMessage={registrationMessage}
                setRegistrationMessage={(message) =>
                  setRegistrationMessage(message)
                }
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function Login({
  email,
  setEmail,
  password,
  setPassword,
  handleLogin,
  isVisible,
  setIsVisible,
  handleResetPassword,
  resetPasswordMessage,
  setResetPasswordMessage,
}) {
  return (
    <>
      {isVisible ? (
        <div className="row justify-content-center">
          {resetPasswordMessage !== "" && (
            <div className="text-center">
              <h6>{resetPasswordMessage}</h6>
            </div>
          )}
          <form
            onSubmit={handleResetPassword}
            className="row col-12 justify-content-center"
          >
            <div className="form-group col-12">
              <label htmlFor="email" className="col-form-label col-md-5">
                Username (Email)
              </label>
              <input
                id="email"
                className="form-control input-lg"
                name="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div
              className="form-group col-12"
              style={{ display: "flex", marginBottom: 0 }}
            >
              <div className="col-6 text-center">
                <button
                  className="btn btn-md btn-ryoSilver"
                  type="button"
                  onClick={() => {
                    setIsVisible(false);
                    setResetPasswordMessage("");
                  }}
                >
                  Go Back
                </button>
              </div>
              <div className="col-6 text-center">
                <button className="btn btn-md btn-ryoForest" type="submit">
                  Reset
                </button>
              </div>
            </div>
          </form>
        </div>
      ) : (
        <div className="row justify-content-center">
          <form
            onSubmit={handleLogin}
            className="row col-12 justify-content-center"
          >
            <div className="form-group col-12">
              <label
                htmlFor="email"
                className="col-form-label col-md-5 col-sm-12"
              >
                Username (Email)
              </label>
              <input
                id="email"
                className="form-control input-lg"
                name="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="password" className="col-form-label col-md-4">
                Password
              </label>
              <input
                id="password"
                className="form-control input-lg"
                name="email"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <button className="btn btn-md btn-ryoForest col-md-4" type="submit">
              Login
            </button>
          </form>
          <div id="forgotPassword">
            <p onClick={() => setIsVisible(true)}>Forgot Password?</p>
          </div>
        </div>
      )}
    </>
  );
}

function Register({
  firstName,
  setFirstName,
  lastName,
  setLastName,
  password,
  setPassword,
  email,
  setEmail,
  handleCreateUser,
  registrationMessage,
  setRegistrationMessage,
}) {
  return (
    <div className="row justify-content-center">
      {registrationMessage !== "" ? (
        <div className="text-center">
          <h6>{registrationMessage}</h6>
          <button
            className="btn btn-md btn-ryoSilver"
            onClick={() => setRegistrationMessage("")}
          >
            Go Back
          </button>
        </div>
      ) : (
        <form
          onSubmit={handleCreateUser}
          className="row col-12 justify-content-center"
        >
          <div className="form-group">
            <label htmlFor="firstName" className="col-form-label col-md-4">
              First Name
            </label>
            <input
              id="firstName"
              className="form-control input-lg"
              name="firstName"
              type="text"
              required
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="lastName" className="col-form-label col-md-4">
              Last Name
            </label>
            <input
              id="lastName"
              className="form-control input-lg"
              name="lastName"
              type="text"
              required
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="email" className="col-form-label col-md-5">
              Username (Email)
            </label>
            <input
              id="email"
              className="form-control input-lg"
              name="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="password" className="col-form-label col-md-4">
              Password
            </label>
            <input
              id="password"
              className="form-control input-lg"
              name="password"
              type="password"
              required
              pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" //1 lowercase, 1 uppercase, 1 number, 8+ chars
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          {password !== "" && (
            <div id="passwordPattern">
              <h6>Password must contain the following:</h6>
              <p className={password.match(/[a-z]/g) ? "valid" : "invalid"}>
                A <b>lowercase</b> letter
              </p>
              <p className={password.match(/[A-Z]/g) ? "valid" : "invalid"}>
                A <b>capital (uppercase)</b> letter
              </p>
              <p className={password.match(/[0-9]/g) ? "valid" : "invalid"}>
                A <b>number</b>
              </p>
              <p className={password.length > 7 ? "valid" : "invalid"}>
                Minimum <b>8 characters</b>
              </p>
            </div>
          )}
          <button className="btn btn-md btn-ryoForest col-md-6" type="submit">
            Create Account
          </button>
        </form>
      )}
    </div>
  );
}

export default LoginRegister;
